// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Document } from '@shared/data-access/types/engine-types';
import { documentsAdapter, initialState } from './documents-repository-state';

export const documentsRepositorySlice = createSlice({
  initialState: () => initialState,
  name: 'documentsRepository',
  reducers: {
    reset: () => initialState,

    resetByClientId: (
      state,
      { payload: { clientId } }: PayloadAction<{ clientId: number }>,
    ) => {
      const entries = documentsAdapter.getSelectors().selectAll(state.documents);

      const idsToRemove = entries
        .filter(document => document.client_id === clientId)
        .map(document => document.id);

      documentsAdapter.removeMany(state.documents, idsToRemove);
    },

    upsertDocuments: (
      state,
      { payload }: PayloadAction<ReadonlyArray<Document>>,
    ) => {
      documentsAdapter.upsertMany(state.documents, payload);
    },

    removeDocument: (
      state,
      { payload: { documentId } }: PayloadAction<{ documentId: number }>,
    ) => {
      documentsAdapter.removeOne(state.documents, documentId);
    },
  },
  extraReducers: () => {
    return;
  },
});
